type NormalizeNumberInputOptions = {
  value: string | number
  min?: number
  max?: number
  empty?: boolean
  allowDecimals?: boolean
}

export function normalizeNumberInput(
  options: NormalizeNumberInputOptions,
): number | null {
  const {
    value,
    min = 0,
    max = 10_000_000,
    empty = false,
    allowDecimals = true,
  } = options

  const effectiveMin = min < 0 ? 0 : min

  if (value === '' || value === null || value === undefined) {
    return empty ? null : effectiveMin
  }

  let normalized = String(value).replace(',', '.')
  let sign = ''

  if (normalized.startsWith('-')) {
    sign = '-'
    normalized = normalized.slice(1)
  }

  normalized = normalized.replace(/[^0-9.]/g, '')
  normalized = normalized.replace(/^0+(?=\d)/, '')

  const parts = normalized.split('.')

  if (parts.length > 2) {
    const last = parts.pop()
    normalized = parts.join('') + '.' + last
  }

  const finalParts = normalized.split('.')

  if (!allowDecimals) {
    normalized = finalParts[0]
  } else {
    if (finalParts[1]) {
      finalParts[1] = finalParts[1].slice(0, 2)
      normalized = finalParts[0] + '.' + finalParts[1]
    }
  }

  if (normalized.startsWith('.')) {
    normalized = '0' + normalized
  }

  if (normalized.startsWith('-.')) {
    normalized = '-0' + normalized.slice(2)
  }

  normalized = sign + normalized

  let num = normalized as any as number

  if (Number.isNaN(num)) {
    return empty ? null : min
  }

  if (num > max) num = max
  if (num < min) num = effectiveMin

  return num
}
